<ng-template #toggle>
	<div
		*ngIf="isMobile$ | async"
		class="flex flex-row items-center justify-start"
	>
		<button
			(click)="this.toggleNav()"
			class="menu-button flex flex-col items-center justify-center"
			mat-icon-button
		>
			<mat-icon>menu</mat-icon>
		</button>
	</div>
</ng-template>
